(function($) {
	
	'use strict';

	$.fn.checkbox = function(options) {

		return this.each(function () {
			if ($(this).is('[type="checkbox"]')) {
				var checkbox = $(this);
				checkbox.hide();
				var fakeCheckbox = $('<div class="selectables-checkbox">');
				fakeCheckbox.on('click', function () {
					checkbox.click();
				});
				fakeCheckbox.insertBefore(checkbox);
				checkbox.on('change', function () {
					if (!checkbox.prop('checked')) {
						fakeCheckbox.removeClass('checked');
					}
					else {
						fakeCheckbox.addClass('checked');
					}
				});
				checkbox.prop('checked', 0); // Reset in Firefox	
			}
		});
	};
	
	$.fn.radio = function(options) {

		return this.each(function () {
			if ($(this).is('[type="radio"]')) {
				var radio = $(this);
				var name = radio.attr('name');
				radio.hide();
				var fakeRadio = $('<div class="selectables-radio" data-name="' + name + '">');
				fakeRadio.on('click', function () {
					radio.click();
				});
				fakeRadio.insertBefore(radio);
				radio.on('change', function () {
					$('.selectables-radio[data-name="' + name + '"]').removeClass('checked');
					if (!radio.prop('checked')) {
						fakeRadio.removeClass('checked');
					}
					else {
						fakeRadio.addClass('checked');
					}
				});
				radio.prop('checked', 0); // Reset in Firefox	
			}
		});
	};
	
	$.fn.selectbox = function(options) {
		
		options = $.extend({
			includeLabel: true,
			exclusive: true,
			multiple: true
		}, options);

		return this.each(function () {
			if ($(this).is('select')) {
				var selectbox = $(this);
				selectbox.hide();
				var fakeSelectbox = $('<div class="selectables-selectbox">');
				var fakeLabel = $('<div class="selectables-label">');
				fakeLabel.appendTo(fakeSelectbox);
				if (options.includeLabel) {
					var label = $('label[for="' + selectbox.attr('name') + '"]');
					if (label.length === 1) {
						label.hide();
						fakeLabel.text(label.text());
					}
				}
				else {
					fakeLabel.text('-- Please choose --');	
				}
				var fakeOptions = $('<div class="selectables-options">');
				fakeOptions.appendTo(fakeSelectbox);
				selectbox.find('option').each(function () {
					var fakeOption = $('<div class="selectables-option" data-value="' + $(this).attr('value') + '">');
					var value = $(this).val();
					var text = $(this).text();
					fakeOption.text(text);
					fakeOption.appendTo(fakeOptions);
					fakeOption.on('click', function (e) {
						fakeLabel.text(text);
						fakeSelectbox.addClass('selected');
						if (!options.multiple) {
							$(this).siblings().removeClass('selected');
							selectbox.val(value);
						}
						else {
							selectbox.find('option[value="' + value + '"]').attr('selected', true);	
						}
						$(this).addClass('selected');
						selectbox.trigger('change');
					});
				});
				fakeSelectbox.insertBefore(selectbox);
				fakeSelectbox.on('click', function (e) {
					e.stopPropagation();
					if (options.exclusive) {
						$('.selectables-selectbox').not(fakeSelectbox).removeClass('focus');	
					}
					fakeSelectbox.toggleClass('focus');	
				});
				$(window).on('click', function () {
					fakeSelectbox.removeClass('focus');
				});
			}
		});
	};
		
}(jQuery));